import script from "./IntermediaryAutoSuggest.vue?vue&type=script&setup=true&lang=js"
export * from "./IntermediaryAutoSuggest.vue?vue&type=script&setup=true&lang=js"

import "./IntermediaryAutoSuggest.vue?vue&type=style&index=0&id=f87965c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f87965c4"]])

export default __exports__